var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXmarkSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.05 11.05a1 1 0 0 0 0 1.414L14.586 16l-3.536 3.536a1 1 0 0 0 1.414 1.414L16 17.414l3.535 3.536a1 1 0 0 0 1.415-1.414L17.414 16l3.536-3.536a1 1 0 1 0-1.415-1.414L16 14.586l-3.536-3.536a1 1 0 0 0-1.414 0"
})));
export default SvgXmarkSmall;